export const MIGRATION_WINDOW_DURATION = 7;

export const getLegacyMigrationTopbarMessage = (daysLeft: number): string =>
  daysLeft > 0
    ? `Your LiveChat upgrades to Text in ${daysLeft} ${daysLeft === 1 ? 'day' : 'days'}.`
    : 'Your LiveChat upgrades to Text soon.';

export const LEGACY_MIGRATION_MODAL_TITLE = 'Your LiveChat upgrades to Text';

export const LEGACY_MIGRATION_COPY = {
  primaryAction: 'See Text now',
  downloadTextApp: 'Download Text App',
} as const;

export const LEGACY_MIGRATION_MODAL_COPY = {
  descriptionHighlight: '220 improvements across the Inbox, customer profiles, reporting, and more.',
  description:
    'Reach visitors with targeted campaigns, see their chats and tickets together, and use AI to answer questions and qualify leads.',
  primaryAction: "See what's new",
  downloadTextApp: 'Download Text App',
} as const;

export enum LegacyMigrationEvent {
  ModalDisplayed = 'Migration Info Modal Displayed',
  ModalDismissed = 'Migration Info Modal Dismissed',
  ModalRemindMeLaterClicked = 'Migration Info Modal Remind Me Later Clicked',
  ModalPrimaryActionClicked = 'Migration Info Modal Primary Action Clicked',
  ModalDownloadTextAppClicked = 'Migration Info Modal Download Text App Clicked',
  TopbarDisplayed = 'Migration Info Alert Displayed',
  TopbarDismissed = 'Migration Info Alert Dismissed',
  TopbarCtaClicked = 'Migration Info Alert Cta Clicked',
  TopbarDownloadTextAppClicked = 'Migration Info Alert Download Text App Clicked',
}
